import axios from 'axios';
import Vue from 'vue';
import router from '@/router';
import store from '@/store';
let qs = require('qs');

// 基层使用---使用中
axios.defaults.withCredentials = true; //允许跨域携带cookie信息
let isdebug = 2; // 1 本地  2 测试   3  正式
let path = isdebug == 1 ? '/sapi' : isdebug == 2 ? '/admin' : isdebug == 3 ? 'http://127.0.0.1:5200' : '';
var service = axios.create({
	baseURL: path,
	// process.env.NODE_ENV === "production" ? "https://caihai123.com" : "/api",
	timeout: 50000
});

// 添加请求拦截器
service.interceptors.request.use(
	(config) => {
		// console.log(store.getters.token);
		// 添加token  -header头
		if (store.getters.token) {
			config.headers.token = store.getters.token;
		}
		if (config.method.toLocaleLowerCase() == 'post') {
			config.data = qs.stringify(config.data);
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// 添加响应拦截器
service.interceptors.response.use(
	// 对响应数据做点什么
	(response) => {
		let ret = response.data;
		if (response.status === 200) {
			if (ret.code == 1) {
				return ret.data;
			} else if (ret.code == 999) {
				store.commit('setToken', '');
				store.commit('setUser', null);
				if (router.currentRoute.path !== '/login') router.replace('/login');
				return Promise.reject(ret.msg);
			} else {
				if (ret.type && (ret.type == 'image/png' || ret.type == 'image/jpg' || ret.type == 'image/jpeg')) {
					return ret;
				} else {
					Vue.prototype.$baseMessage(ret.msg, 'warning');
					return Promise.reject(ret.msg);
				}
			}
		} else {
			Vue.prototype.$baseMessage(ret.msg, 'error');
			return Promise.reject(ret.msg);
		}
	},
	// 对响应错误做点什么
	(error) => {
		Vue.prototype.$baseMessage(error, 'error');
		return Promise.reject(error);
	}
);

export default service;
